import { render } from "./About.vue?vue&type=template&id=0d4bce6c&scoped=true"
const script = {}

import "./About.vue?vue&type=style&index=0&id=0d4bce6c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0d4bce6c"

export default script